export default "__VITE_ASSET__j9U6UZ3b__"